/**
 * L'accès à la base pour les présences de la garderie depuis le bureau
 * (migration `20261101200000_la_vue_des_presences_de_la_garderie`) : la semaine
 * d'une école, et un ✓ ou un ✗ au compte de qui le fait. La base vérifie le
 * rôle (administration, coordination), l'école, l'année, l'avenir et le mois
 * facturé ; l'écran ne fait que présenter.
 */
import { db } from '../payments/db';
import type { SourceDuPointage } from './pointage';
import { lectureDuJour, lireSemaine, type SemaineDeGarderie } from './presences-bureau';

export { lireLesEcoles, type EcoleDeGarderie } from './pointage.supabase';

export async function lireLaSemaine(centerId: string, lundi: string): Promise<SemaineDeGarderie> {
  const { data, error } = await db.rpc('garderie_semaine', { p_center_id: centerId, p_lundi: lundi });
  if (error) throw error;
  return lireSemaine(data);
}

/** Rend l'état après le geste, tel que la base le dit. */
export async function pointerDepuisLeBureau(enfantId: string, date: string, plageId: string, present: boolean): Promise<boolean> {
  const { data, error } = await db.rpc('garderie_pointer', { p_enfant_id: enfantId, p_date: date, p_plage_id: plageId, p_present: present });
  if (error) throw error;
  return (data as { present?: boolean } | null)?.present === true;
}

/**
 * La liste du téléphone, depuis Gestion : la semaine de l'école lue par
 * `garderie_semaine`, réduite à la date ; le geste par `garderie_pointer`, au
 * compte de qui le fait. Pas de fiche : elle passe par le lien de l'animateur.
 */
export function sourceDuBureau(centerId: string): SourceDuPointage {
  return {
    cle: `bureau-${centerId}`,
    lire: async (date) => lectureDuJour(await lireLaSemaine(centerId, date), date),
    pointer: async (enfantId, date, plageId, present) => ({ codeRequis: false, present: await pointerDepuisLeBureau(enfantId, date, plageId, present) }),
  };
}
